import React from 'react';
import { motion } from 'framer-motion';
import { Eyebrow, HUDBrackets } from './UI';
export const Mission = () => {
  return <section className="bg-base-black pt-[40px] pb-[40px] overflow-hidden relative" data-id="element-1167" data-mp="4soks0asdzey">
      {/* Section-level metadata header — ties image and copy together as one editorial spread */}
      <div className="container mx-auto px-6 md:px-12 mb-12" data-id="element-1168" data-mp="ekc57h8xeg6x">
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-dark-3 pb-4 max-w-[1200px] mx-auto" data-id="element-1169" data-mp="3mz2x5uteq1b8">
          <div className="flex items-center gap-4 font-barlow text-[10px] tracking-[2px] text-text-dimmed uppercase" data-id="element-1170" data-mp="3i0t1lj3rsyp3">
            <span className="text-acid-green" data-id="element-1171" data-mp="3w0k7ewk4v8s0">●</span>
            <span data-id="element-1172" data-mp="3ry77ios2i535">FILE 002 — ORIGIN DOSSIER</span>
            <span className="hidden md:inline text-dark-3" data-id="element-1173" data-mp="3rwm92o2mu200">|</span>
            <span className="hidden md:inline" data-id="element-1174" data-mp="1b90i5z5sbd9h">CLASSIFIED: PUBLIC RELEASE</span>
          </div>
          <div className="font-barlow text-[10px] tracking-[2px] text-text-dimmed uppercase" data-id="element-1175" data-mp="178hrw9jjif9e">
            EST. 2019 — BLACKOUT UNIT TEAM
          </div>
        </div>
      </div>

      <div className="container mx-auto px-6 md:px-12" data-id="element-1176" data-mp="1n9atrpk9t44y">
        <div className="grid grid-cols-1 lg:grid-cols-[5fr_6fr] gap-10 lg:gap-14 max-w-[1200px] mx-auto items-start" data-id="element-1177" data-mp="1n7rbxuiyul12">
          {/* Left Column - Framed editorial photo */}
          <div className="w-full" data-id="element-1178" data-mp="1wa90ifm3fpr8">
            <div className="relative" data-id="element-1179" data-mp="1w97ni5liot6v">
              {/* Image frame */}
              <div className="relative border border-acid-green/25 bg-dark-1 aspect-[4/5] overflow-hidden" data-id="element-1180" data-mp="zkro7hslv5gk">
                <HUDBrackets data-id="element-1181" data-mp="13m4ozdgucigm" />

                {/* Subject image — slow Ken Burns, NO opacity fade-in (caused floating feel) */}
                <motion.img initial={{
                scale: 1.05
              }} whileInView={{
                scale: 1.18
              }} viewport={{
                once: false,
                amount: 0.3
              }} transition={{
                duration: 9,
                ease: [0.16, 1, 0.3, 1]
              }} src="https://cdn.magicpatterns.com/uploads/2MZ6FLTKZgXiYN2qw8LbL6/hf_20260505_165931_e3d45bcb-ce1e-4314-a132-aca520cf39ff.png" alt="Blackout Unit operator carrying the mask box through the field" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-1182" data-mp="18ibrewa13btt" />

                {/* Bottom gradient for caption legibility */}
                <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-base-black via-base-black/70 to-transparent pointer-events-none" data-id="element-1183" data-mp="108k9zmpq06ur" />

                {/* Top-left field tag */}
                <div className="absolute top-4 left-4 font-barlow text-[10px] text-acid-green tracking-[2px] z-10 border border-acid-green/40 px-2 py-1 bg-base-black/60" data-id="element-1184" data-mp="1987cycy3lkpx">
                  FIELD CAPTURE
                </div>

                {/* Top-right coordinates */}
                <div className="absolute top-4 right-4 font-barlow text-[10px] text-white/80 tracking-[2px] z-10 bg-base-black/60 px-2 py-1" data-id="element-1185" data-mp="2t4wdthffej0s">
                  34.0522° N / 118.2437° W
                </div>

                {/* Caption inside frame */}
                <div className="absolute bottom-0 left-0 right-0 p-5 z-10" data-id="element-1186" data-mp="2j81it8id30r9">
                  <div className="font-barlow text-[10px] text-acid-green tracking-[3px] uppercase mb-1" data-id="element-1187" data-mp="2o6min6tpbif6">
                    — Operator on approach —
                  </div>
                  <div className="font-bebas text-[20px] md:text-[22px] text-white leading-tight" data-id="element-1188" data-mp="3gtz2vace3e5b">
                    THE FIRST UNIT EVER DEPLOYED.
                  </div>
                </div>
              </div>

              {/* Caption strip below frame — ties image to copy */}
              <div className="flex items-stretch border border-dark-3 border-t-0 bg-dark-1" data-id="element-1189" data-mp="3uu05ovc7svnf">
                <div className="px-4 py-3 border-r border-dark-3 font-barlow text-[10px] text-acid-green tracking-[2px] flex items-center" data-id="element-1190" data-mp="3us70lkh92jhj">
                  PHOTO 01
                </div>
                <div className="flex-grow px-4 py-3 font-inter text-[11px] text-text-dimmed leading-snug" data-id="element-1191" data-mp="2awt31mm6673l">
                  Field-test cycle 04. Prototype carried into operational
                  conditions before the BLACKOUT UNIT Ultimate Mask was
                  officially released.
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="w-full lg:pt-2" data-id="element-1192" data-mp="2uopn6rdierfp">
            <Eyebrow data-id="element-1193" data-mp="38me5psk3tmhl">THE ORIGIN</Eyebrow>

            <h2 className="text-4xl md:text-[56px] leading-[0.95] mb-8" data-id="element-1194" data-mp="38lcvtretr61g">
              WE WEREN'T LOOKING TO START A BRAND.
              <br data-id="element-1195" data-mp="3kwx54ni2mqj2" />
              <span className="text-acid-green" data-id="element-1196" data-mp="3kwdn76sf8251">
                WE WERE LOOKING FOR A MASK WORTH WEARING.
              </span>
            </h2>

            {/* Lead pull-quote bar — visually anchors the column to the image */}
            <div className="border-l-2 border-acid-green pl-5 py-1 mb-8" data-id="element-1197" data-mp="3uvuqxio445yd">
              <p className="font-barlow font-bold text-[13px] text-white tracking-[1px] uppercase leading-relaxed" data-id="element-1198" data-mp="2rtt0itote95">
                47 masks tested. 24 months of failure. 4 prototypes. One
                standard.
              </p>
            </div>

            <div className="space-y-5 font-barlow text-[16px] md:text-[17px] text-text-body leading-[1.85] text-justify hyphens-auto mb-8" data-id="element-1199" data-mp="cj6odkep2mjx">
              <p data-id="element-1200" data-mp="mft7a3ngn3jb">
                Every operator on our team has worn the cheap versions — the
                ones that fog on the first sprint, crack on the first real hit,
                and belong in a costume bin instead of on your face.
              </p>
              <p data-id="element-1201" data-mp="2nfenmfplg27h">We tested 47 masks over 24 months. Every single one failed.</p>
              <p className="text-white font-medium" data-id="element-1202" data-mp="2ijzaxr3boccn">
                So we built the one that doesn't.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};